import { Grid } from "@mui/material";
import styled from "styled-components";
import { Fragment, useEffect, useState } from "react";
import { DesktopDatePicker as MUIDesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { colors } from "../../../css components/Style";

const DesktopDatePicker = styled(MUIDesktopDatePicker)`
  .MuiTextField-root {
    padding: 8px;
  }

  & label.Mui-focused {
    color: ${colors.publicisBlue};
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.publicisBlue};
  }

  .MuiInputLabel-root {
    color: #333;
    font-size: 16px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    border-radius: 5px;
  }

  .MuiOutlinedInput-root .Mui-disabled {
    border: 1px solid #c4cacb !important;
    &:hover {
      border: 1px solid #c4cacb !important;
    }
  }

  .MuiOutlinedInput-root .Mui-disabled:hover {
    border: 1px solid #c4cacb !important;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border: 1px solid #c4cacb !important;

    &:hover {
      border: 1px solid #c4cacb !important;
    }
  }

  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }

  #mui-7-helper-text {
    color: red;
  }
`;

export default function DatePicker({
  dispatch,
  state,
  field,
  editState,
  formikProps,
}) {
  const [inputValue, setInputValue] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInputValue((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  return (
    <Fragment>
      <Grid size={6}>
        {/* <Mandatory
          dispatch={dispatch}
          state={state}
          editState={editState}
          field={field}
          formikProps={formikProps}
        /> */}
        <DesktopDatePicker
          label={field.label}
          value={
            inputValue[field.name]?.value
              ? new Date(inputValue[field.name].value)
              : null
          }
          onChange={(newValue) => {
            if (!newValue) {
              setInputValue((prev) => ({
                ...prev,
                [field.name]: { value: null },
              }));
              return;
            }

            const date = new Date(newValue);
            const formattedDate = [
              date.getFullYear(),
              String(date.getMonth() + 1).padStart(2, "0"),
              String(date.getDate()).padStart(2, "0"),
            ].join("-");

            // if ((date.getFullYear() + "").length < 3) {
            //   setInputValue((prev) => ({
            //     ...prev,
            //     [field.name]: { value: null },
            //   }));
            //   return;
            // }

            handleDate(formattedDate, field.name, "value");
            setInputValue((prev) => ({
              ...prev,
              [field.name]: { value: formattedDate },
            }));
          }}
          disabled={!editState}
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true, // 🔧 Ensure TextField takes full width
              name: `${field.name}.value`,
              sx: {
                // "& .MuiOutlinedInput-root": {
                //   "& fieldset": {
                //     borderColor: "#167CBF",
                //   },
                //   "&:hover fieldset": {
                //     borderColor: "#167CBF",
                //   },
                //   "&.Mui-focused fieldset": {
                //     borderColor: "#167CBF",
                //   },
                //   "&.Mui-disabled fieldset": {
                //     borderColor: "#c4cacb !important",
                //   },
                //   "&.Mui-disabled:hover fieldset": {
                //     borderColor: "#c4cacb !important",
                //   },
                // },
              },
            },
          }}
        />
      </Grid>
    </Fragment>
  );

  function handleDate(value, name, key) {
    dispatch({
      type: "UPDATE_FIELD",
      formikProps: formikProps,
      payload: { value, name, key },
    });
  }
}
